module.exports = __webpack_public_path__ + "static/miro_photo_banner-a9cf0954a445fdc5e7708adef4681d62.jpg";